import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["time"];

    connect() {
        this.updateCountdown();
        this.timer = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnect() {
        clearInterval(this.timer);
    }

    updateCountdown() {
        const now = new Date();
        const dropDate = this.getNextDropDate();
        const diff = dropDate - now;

        if (diff <= 0) {
            this.timeTarget.textContent = "Drop is live!";
            return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        // Format hours, minutes, and seconds with leading zeros
        const hoursFormatted = String(hours).padStart(2, "0");
        const minutesFormatted = String(minutes).padStart(2, "0");
        const secondsFormatted = String(seconds).padStart(2, "0");

        this.timeTarget.textContent = `${days} day${days !== 1 ? "s" : ""} ${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`;
    }

    // Calculates the next drop date (Saturday at 8 PM IST)
    getNextDropDate() {
        // 8 PM IST equals 14:30 UTC (IST = UTC+5:30)
        const dropDay = 6; // Saturday (0=Sunday, 6=Saturday)
        const dropHourUTC = 14;
        const dropMinuteUTC = 30;

        const now = new Date();
        const nowUTC = new Date(now.getTime() + now.getTimezoneOffset() * 60000);

        let dropDateUTC = new Date(nowUTC);
        dropDateUTC.setUTCHours(dropHourUTC, dropMinuteUTC, 0, 0);

        const currentUTCDay = nowUTC.getUTCDay();
        let daysUntilDrop = (dropDay - currentUTCDay + 7) % 7;
        // If today is Saturday and drop time has passed, set for next week
        if (daysUntilDrop === 0 && nowUTC >= dropDateUTC) {
            daysUntilDrop = 7;
        }

        dropDateUTC.setUTCDate(dropDateUTC.getUTCDate() + daysUntilDrop);
        return dropDateUTC;
    }
}
